import { useState } from 'react';
import { Box } from '@mui/material';
import { teamAccentColor } from '../utils/teamColors';
import type { TeamColor } from '../types';

type TeamIconProps = {
  name: string;
  color?: string | null;
  url?: string | null;
  size?: number;
};

export function TeamIcon({ name, color, url, size = 48 }: TeamIconProps) {
  const [brokenUrl, setBrokenUrl] = useState<string | null>(null);
  const initials = name.trim().split(/\s+/).slice(0, 2).map((word) => word[0]?.toUpperCase() || '').join('') || 'T';
  return (
    <Box
      aria-label={`${name} team icon`}
      sx={{
        width: size, height: size, flexShrink: 0, borderRadius: 1.5, overflow: 'hidden',
        display: 'grid', placeItems: 'center', bgcolor: teamAccentColor((color || 'gray') as TeamColor),
        color: 'white', fontWeight: 900, fontSize: Math.max(14, size * 0.3),
      }}
    >
      {url && brokenUrl !== url
        ? <Box component="img" src={url} alt="" onError={() => setBrokenUrl(url)} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : initials}
    </Box>
  );
}
